import { MsalProvider } from '@azure/msal-react';
import '@fontsource/inter';
import '@fontsource/poppins';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './index.css';
import { msalInstance } from './msalConfig.ts';
import reportWebVitals from './reportWebVitals.js';


// Optional: Add a loading component while MSAL initializes
const Loading = () => <div>Initializing authentication...</div>;

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap the rendering in the initialization promise
msalInstance.initialize()
  .then(() => {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch(error => {
    console.error("Failed to initialize MSAL:", error);
    root.render(
      <React.StrictMode>
        <div className="error">
          <h1>Authentication Error</h1>
          <p>Failed to initialize authentication service.</p>
          <p>Please refresh the page or contact support.</p>
        </div>
      </React.StrictMode>
    );
  });

reportWebVitals();

// --- ADD THIS BLOCK TO DESTROY ANY LINGERING SERVICE WORKERS ---
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
      console.log("Old service worker unregistered.");
    }
  }).catch(function(err) {
    console.log('Service Worker unregistration failed: ', err);
  });
}
